document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js-anmb-link-items').forEach(function(el) {
    if (el.href.includes('klaviyo-modal-open')) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'YkUPq5']);
      });
    }
  });
});